import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { PeriodosAdapter } from '../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import SelectorEjercicio from './selector';

export const SelectorEjercicioContainer = (props: any) => {
	let { permitirNuevo, value, onChange } = props;
	const api = new PeriodosAdapter();
	const { exceptionError, resultError } = useNotifications();
	const _año = parseInt(moment().format('M')) === 1 ? parseInt(moment().format('Y'))-1 : parseInt(moment().format('Y'));
	
	let [minVal, setMinVal] = useState<any>(_año)
	let [maxVal, setMaxVal] = useState<any>(_año)
	let result: any;

	let [localVal, setLocalVal] =useState<any>(value)
  
	useEffect(()=>{
		getEjercicios();
	},[])

	useEffect(()=>{
		setLocalVal(value);
	}, [value])

	const getEjercicios = async () => {
		try {
			result = await api.GetMinMaxEjercicio();
			if(result.data && result.data!=="")
			{
				var ejercicios = result.data || [{AñoInicio: _año, AñoFin: _año}];
				var addAño = 0;
				
				if(permitirNuevo != undefined && permitirNuevo) addAño = 1;
				setMinVal(ejercicios[0].añoInicio);
				setMaxVal(ejercicios[0].añoFin + addAño)
				if(localVal > ejercicios[0].añoFin + addAño) onChange(ejercicios[0].añoFin + addAño);
				
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  return <SelectorEjercicio {...props} minVal={minVal} maxVal={maxVal} value={localVal}/>
};

export default SelectorEjercicioContainer;